// HeroSection.jsx
import React, { useState, useEffect } from "react";
import "./HeroSection.css";

export default function HeroSection() {
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    // Preload the high-quality image
    const img = new Image();
    img.src = "https://arely-media.s3.us-east-1.amazonaws.com/panoramic_large.jpg";
    img.onload = () => {
      setImageLoaded(true);
    };
  }, []);

  return (
    <section id="hero" className={`hero-section ${imageLoaded ? 'image-loaded' : ''}`}>
      <div className="hero-background-placeholder"></div>
      <div className="hero-overlay">
        <h1 className="hero-title">
          ARELY CONSTRUCTION & PAINTING LLC
        </h1>
        <p className="hero-subtitle">
          Years of experience serving Roanoke, VA and nearby areas.
        </p>
        <div className="promotion-banner">
          <div className="promotion-content">
            <span className="promotion-icon">💰</span>
            <h2 className="promotion-title">Ask for Free Estimates</h2>
            <p className="promotion-text">
              Contact us today for a free, no-obligation estimate!
              Your satisfaction guaranteed with premium quality work.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
